import { Box, Button, ButtonGroup, Divider, Paper } from "@mui/material";
// import TextField from "@mui/material/TextField";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState
} from "react";
import DataTable, { createTheme } from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CardDataLoader from "../../../../uiComponents/CardDataLoader/CardDataLoader";
import { bdDateFormat } from "../../../../utility/dateConversion";

const axios = require("axios").default;

const BillList = forwardRef((props, ref) => {
  const patientIdRedux = useSelector((state) => state.patientId);
  const dispatch = useDispatch();
  // state
  const [isLoading, setIsLoading] = useState(true);
  const [orderList, setOrderList] = useState([]);
  const [tableFontSize, setTableFontSize] = useState(15);
  const [confirmDeleteId, setConfirmDeleteId] = useState(0);
  // state

  // special
  useImperativeHandle(ref.billListRef, () => ({
    getOrderListByPatientId,
  }));
  // special //

  // handle Managemnt

  const handleFontSizeChange = (value) => {
    setTableFontSize(value);
    localStorage.setItem("style_billList_fontSize", value);
  };
  const printBill = (orderId) => {
    window.open("/bill-print/" + orderId);
  };
  // handle Managemnt  //

  // dataTable sectins
  const getLocalStyle = () => {
    const localFontSize = localStorage.getItem("style_billList_fontSize");
    console.log("localFontSize-101", localFontSize, typeof localFontSize);
    typeof localFontSize === "string"
      ? setTableFontSize(localFontSize)
      : setTableFontSize(17);
  };

  const handleDeleteOrder = (item) => {
    console.log(item);
    // getOrderListByPatientId(patientIdRedux);
    setIsLoading(true);
    axios.delete("billing-order-master/"+item.id)
    .then(response=>{
      setIsLoading(false);
      toast.success("Order ID : "+item.id+ " delete success.")
      getOrderListByPatientId(patientIdRedux)
      console.log(response)
    })
    .catch(error=>{
      setIsLoading(false);
      toast.error("Something is wrong")
      console.log(error)
    })
  };

  const columns = [
    {
      name: "ID",
      width: "50px",
      selector: (row) => `${row.id}`,
    },
    {
      name: "Total BIll",
      width: "130px",
      selector: (row) => parseInt(row.total_bill),
      sortable: true,
    },

    {
      name: "Total Paid",
      width: "130px",
      selector: (row) => parseInt(row.total_paid),
    },
    {
      name: "Discount",
      width: "130px",
      selector: (row) => parseInt(row.discount),
    },
    {
      name: "DUE",
      width: "130px",
      selector: (row) => row.total_bill - row.total_paid - row.discount,
    },
    {
      name: "Entry Date",
     
      selector: (row) => {
        return bdDateFormat(row.created_at);
      },
    },

    {
      name: "Action",
      
      selector: (row) => {
        return (
          <ButtonGroup variant="outlined" aria-label="outlined button group">
            {confirmDeleteId===row.id ? (
              <>
                <Button
                  onClick={() => handleDeleteOrder(row)}
                  color="error"
                  variant="contained"
                >
                  CONFIRM DELETE
                </Button>
                <Button
                
                  color="warning"
                  onClick={() => setConfirmDeleteId(0)}
                >
                  CANCEL
                </Button>
              </>
            ) : (
              <>
                <Button onClick={() => handleOpenDetails(row)} color="success">
                  EDIT
                </Button>
                <Button color="warning" onClick={() => printBill(row.id)}>
                  PRINT
                </Button>
                <Button onClick={() => setConfirmDeleteId(row.id)} color="error">
                  DELTE
                </Button>
              </>
            )}
          </ButtonGroup>
        );
      },
    },
  ];
  createTheme(
    "solarized",
    {
      text: {
        primary: "#268bd2",
        secondary: "#2aa198",
      },
      background: {
        default: "#002b36",
      },
      context: {
        background: "#cb4b16",
        text: "#FFFFFF",
      },
      divider: {
        default: "#073642",
      },
      action: {
        button: "rgba(0,0,0,.54)",
        hover: "rgba(0,0,0,.08)",
        disabled: "rgba(0,0,0,.12)",
      },
    },
    "dark"
  );
  createTheme(
    "dentrino",
    {
      text: {
        fontSize: "30px",
      },
    },
    "light"
  );
  const customStyles = {
    rows: {
      style: {
        fontSize: tableFontSize + "px",
        // fontSize: "17px",
        minHeight: "72px", // override the row height
      },
    },
    headCells: {
      style: {
        fontSize: tableFontSize + "px",
        fontWeight: 600,
        // fontSize: "20px",
        paddingLeft: "8px", // override the cell padding for head cells
        paddingRight: "8px",
      },
    },
    cells: {
      style: {
        paddingLeft: "8px", // override the cell padding for data cells
        paddingRight: "8px",
      },
    },
  };
  // dataTable sectins //
  // axios
  const getOrderListByPatientId = (patientId) => {
    setIsLoading(true);
    axios
      .get("/billing-order-master/show-by-patient-id/" + patientId)
      .then((response) => {
        setIsLoading(false);
        console.log(response.data);
        setOrderList(response.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const getOrderDetailsByOrderMasterId = (orderMasterId) => {
    setIsLoading(true);
    axios
      .get("/billing-order/showdetailsbyid/" + orderMasterId)
      .then((response) => {
        toast.info(
          "Edit form for order id  : " + orderMasterId + " is ready. "
        );
        window.history.pushState("", "", window.location.pathname);
        window.location.hash = "billingSection";
        setIsLoading(false);
        console.log("orderDetails", response.data);
        const orderItemsList = response.data.billingOrderDetail;
        const transactionList = response.data.billingOrderTransaction;
        dispatch({
          type: "transactionList_loadData",
          payload: transactionList,
        });

        // setOrderList(response.data);
        // const newItem = { ...item };
        //{id: 1, service_name: 'Service 1', mrp: 500, qty: 2},
        // console.log("handleAdd-", item);
        const newCartItems = [];
        orderItemsList.forEach((element) => {
          const tempItem = {
            id: element.billing_service_head_id,
            mrp: element.mrp,
            qty: element.qty,
            service_name: element.service_extra_name,
          };
          newCartItems.push(tempItem);
        });
        dispatch({
          type: "cartItems_loadData",
          payload: newCartItems,
        });
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  // axios //
  const handleOpenDetails = (item) => {
    const masterId = item.id;
    getOrderDetailsByOrderMasterId(masterId);
    dispatch({
      type: "masterPaid_update",
      payload: parseInt(item.total_paid),
    });
    dispatch({
      type: "discount_update",
      payload: parseInt(item.discount),
    });
    dispatch({
      type: "orderId_add",
      payload: parseInt(masterId),
    });
  };
  // useEffect
  useEffect(() => {
    getLocalStyle();
    // getOrderListByPatientId();
  }, []);
  // useEffect //

  return (
    <Paper sx={{ padding: 1 }}>
      <Box sx={{ fontSize: "30px", marginBottom: 3, marginTop: 3 }}>
        Billing History
      </Box>
      <Divider />
      <Box sx={{ position: "relative" }}>
        {isLoading && <CardDataLoader></CardDataLoader>}
        <DataTable
          columns={columns}
          data={orderList}
          direction="auto"
          fixedHeaderScrollHeight="300px"
          highlightOnHover
          pagination
          responsive
          striped
          subHeaderAlign="right"
          subHeaderWrap
          theme="dentrino"
          customStyles={customStyles}
        />
      </Box>
      {/* <Box sx={{marginTop:3}}>
        <TextField label="Font Size" value={tableFontSize} onChange={e=>handleFontSizeChange(e.target.value)} size="small" sx={{width:70}} type="number" />
      </Box> */}
    </Paper>
  );
});

export default BillList;
